import { useQuery } from "@apollo/client";

import { GET_TEMPLATE_VERSION } from "./gql";

const useTemplateVersion = (templateId?: string, versionId?: string) => {
  return useQuery(GET_TEMPLATE_VERSION, {
    variables: {
      id: templateId!,
      versionId: versionId!,
    },
    // APOLLO CLIENT UPDATE
    nextFetchPolicy: "cache-first",
  });
};

export default useTemplateVersion;
